export default {
  COLOR_SCHEME: 'color-scheme',
  HORIZONTAL_CONTENT_ALIGNMENT: 'horizontal-content-alignment',
  VERTICAL_CONTENT_ALIGNMENT: 'vertical-content-alignment',
  BORDER: 'border',
  SHADOW: 'shadow',
  CORNERS: 'all-corners',
  VERTICAL_SPACING: 'vertical-spacing',
  HORIZONTAL_SPACING: 'horizontal-spacing',
  HORIZONTAL_GAP: 'horizontal-gap',
  VERTICAL_GAP: 'vertical-gap',
  NO_WRAP: 'no-wrap',
  COLUMN_WIDTH: 'column-width',
  COLUMN_HEIGHT: 'column-height',
  CORNERS_SECTION: 'corners',
  SPACING_SECTION: 'spacing',
};
